/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';

import messages from '../../messages';
import { EditorField } from '../editor/EditorField';

type Props = {
	value: string;
	onChange: (value: string) => void;
	fieldId: string;
	hideLabel?: boolean;
	isCompact?: boolean;
	isDisabled?: boolean;
};

export const CommentField = ({
	value,
	onChange,
	fieldId,
	hideLabel = false,
	isCompact = false,
	isDisabled = false,
}: Props): JSX.Element => {
	return (
		<EditorField
			name={fieldId}
			label={messages.commentFieldLabel}
			placeholder={messages.commentPlaceholder}
			value={value}
			onChange={onChange}
			hideLabel={hideLabel}
			maxHeight={isCompact ? 160 : 300}
			appearance="chromeless"
			isDisabled={isDisabled}
		/>
	);
};
